import * as CONSTRUCTOR from '../../generate';

export const sharedMediaResponse = CONSTRUCTOR.FRAGMENT({
  name: 'SharedMedia',
  fragmentName: 'SharedMediaResponseFields',
  fields: `{
    id
    parent_type
    parent_id
    file_name
    file_type
    file_content_type
    file_url
    uploader_name
    uploaded_at
    created_at
    updated_at
  }`,
});

export const sharedMediaListResponse = CONSTRUCTOR.FRAGMENT({
  name: 'ListSharedMediasResponse',
  fragmentName: 'SharedMediaListResponseFields',
  fields: `{
    shared_medias {
      id
      parent_type
      parent_id
      file_name
      file_type
      file_url
      uploaded_at
      created_at
    }
    total_count
    limit
    offset
  }`,
});

export const streamSharedMediaFileResponse = CONSTRUCTOR.FRAGMENT({
  name: 'StreamSharedMediaFileResponse',
  fragmentName: 'StreamSharedMediaFileResponseFields',
  fields: `{
    file_content
    content_type
    content_disposition
    cache_control
    file_name
    url
  }`,
});

export const sharedMediaFileResponse = CONSTRUCTOR.FRAGMENT({
  name: 'SharedMediaFileResponse',
  fragmentName: 'SharedMediaFileResponseFields',
  fields: `{
    file_content
    content_type
    content_disposition
    cache_control
    file_name
    fileName
    url
  }`,
});
